import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Row } from 'reactstrap';
import { without, range, omit } from 'underscore';
import Checkbox from './field/checkbox';
import Field from './field/field';

function RenderCheckbox(props) {
  const { input, meta, ...additionalProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);

  return (
    <Checkbox
      {...additionalProps}
      type="checkbox"
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.length > 1 && newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

function RenderRadio(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked = input.value === props.value;

  return (
    <Checkbox
      {...checkboxProps}
      type="radio"
      checked={checked}
      onChange={e => {
        const { checked, value } = e.target;

        var newValue = checked ? value : '';

        return input.onChange(newValue);
      }}
    />
  );
}

function RenderOption(props) {
  const { label, input, meta, invalid, ...additionalProps } = props;

  return <option {...additionalProps}>{label}</option>;
}

class RadioFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const { renderType } = this.props;

    switch (renderType) {
      case 'checkbox':
      case 'radio':
      default:
        return this.renderCheckboxOrRadios();
      case 'select':
        return this.renderSelect();
    }
  }

  renderCheckboxOrRadios() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1}`;
    const {
      className,
      numCols,
      numColsSm,
      numInnerCols,
      numInnerColsSm,
      type,
      items,
      renderType,
      invalid,
      ...props
    } = this.props;
    const colSize = Math.ceil(12 / numCols);
    const colSizeSm = Math.ceil(12 / numColsSm);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const colInnerSizeSm = Math.ceil(12 / numInnerColsSm);
    const numPerCol = Math.ceil(items.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;

    return (
      <Row className={className}>
        {range(numCols).map(col => {
          return (
            <Col key={col} sm={colSizeSm} md={colSize}>
              <FormGroup>
                <Row>
                  {range(numInnerCols).map(innerCol => {
                    return (
                      <Col key={innerCol} sm={colInnerSizeSm} md={colInnerSize}>
                        {range(numPerInnerCol).map(() => {
                          const item = items[i];
                          const Component = this.getItemComponent();
                          i++;

                          return item ? (
                            <Component
                              {...props}
                              key={i}
                              className={labelClassName}
                              value={
                                item.value !== undefined || item.id !== undefined
                                  ? item.value || item.id
                                  : item
                              }
                              label={item.label || item.name || item}
                            />
                          ) : null;
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    );
  }

  renderSelect() {
    const {
      componentClass = Field,
      className,
      items,
      label,
      renderType,
      ...props
    } = this.props;
    const optionProps = omit(
      props,
      'numCols',
      'numInnerCols',
      'numColsSm',
      'numInnerColsSm'
    );
    const Component = componentClass;

    return (
      <Component type="select" {...props.input} invalid={props.invalid} meta={props.meta}>
        {label && <RenderOption {...optionProps} value="" label={label} />}
        {items.map(function (item, i) {
          return (
            <RenderOption
              {...optionProps}
              key={i}
              value={
                item.value !== undefined || item.id !== undefined
                  ? item.value || item.id
                  : item
              }
              label={
                item.label !== undefined || item.name !== undefined
                  ? item.label || item.name
                  : item
              }
            />
          );
        })}
      </Component>
    );
  }

  getItemComponent() {
    const { renderType } = this.props;

    switch (renderType) {
      case 'checkbox':
      default:
        return RenderCheckbox;
      case 'radio':
        return RenderRadio;
    }
  }
}

RadioFilter.defaultProps = {
  numCols: 2,
  numInnerCols: 1,
  numColsSm: 1,
  numInnerColsSm: 1
};

export default RadioFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter.js